























































import { saveTermsAndConditions } from '@/services/user'
import { logInfoEvent } from '@/services/utils/logging'
import { isPosteTheme } from '@/components/RenderWithTheme.vue'
import WithThemeTitle from '../../../components/WithThemeTitle.vue'

export default {
  name: 'TermsAndConditions',
  components: { WithThemeTitle },
  props: {
    name: { type: String, default: '' },
    showModal: { type: Boolean }
  },
  computed: {
    isPosteTheme() {
      return isPosteTheme
    }
  },
  methods: {
    handleAgree() {
      saveTermsAndConditions()
      logInfoEvent('T&C Accepted')
      this.$emit('userHasAgreed', true)
    },
    handleClose() {
      this.$emit('closeModal', false)
    }
  }
}
